import { fork, take, call, put } from 'redux-saga/effects'

import {
  changeSubscriptionPlanRes,
  checkoutSummaryResponse,
  fetchPaymentIntentResponse,
  fetchPIDirectCheckoutResponse,
  fetchProductPIResponse,
  fetchProviderCheckoutResponse,
  fetchSubscribedDataRes,
  fetchSubscribedReceiptRes,
  fetchSubscriptionPIPageRes,
  getProviderPlaceOrderResponse,
  getProviderPlaceOrderV2Response,
  paymentUpdateMembershipPageRes,
  sendOrderPlaceResponse,
  zeroSendOrderResponse
} from './actions'
import types from './types'
import { checkoutData } from '../../api/checkout'
import { postAPIWithoutModule, apiDirect, postAPI } from '../../api/generic'


export function* doCheckoutSummary() {
  while (true) {
    // console.log('is called')
    const { payload } = yield take(types.CHECKOUT_SUMMARY)
    const response = yield call(checkoutData, payload)
    yield put(checkoutSummaryResponse(response))
  }
}

export function* doFetchPaymentIntent() {
  while (true) {
    // console.log('is called')
    const { payload } = yield take(types.PAYMENT_INTENT)
    const response = yield call(postAPIWithoutModule, payload)
    yield put(fetchPaymentIntentResponse(response))
  }
}

export function* doFetchPIDirectCheckout() {
  while (true) {
    // console.log('is called')
    const { payload } = yield take(types.PI_DIRECT_CHECKOUT)
    const response = yield call(postAPIWithoutModule, payload)
    yield put(fetchPIDirectCheckoutResponse(response))
  }
}

export function* doSendOrderPlace() {
  while (true) {
    // console.log('is called')
    const { payload } = yield take(types.SEND_ORDER_PLACE)
    const response = yield call(postAPIWithoutModule, payload)
    yield put(sendOrderPlaceResponse(response))
  }
}

export function* doZeroSendOrderPlace() {
  while (true) {
    // console.log('is called')
    const { payload } = yield take(types.ZERO_SEND_ORDER_PLACE)
    const response = yield call(postAPIWithoutModule, payload)
    yield put(zeroSendOrderResponse(response))
  }
}

export function* doProviderCheckout() {
  while (true) {
    // console.log('is called')
    const { payload } = yield take(types.PROVIDER_CHECKOUT)
    const response = yield call(postAPIWithoutModule, payload)
    yield put(fetchProviderCheckoutResponse(response))
  }
}

export function* doProviderPlaceOrder() {
  while (true) {
    // console.log('is called')
    const { payload } = yield take(types.PROVIDER_PLACEORDER)
    const response = yield call(postAPIWithoutModule, payload)
    yield put(getProviderPlaceOrderResponse(response))
  }
}

export function* doProviderPlaceOrderV2() {
  while (true) {
    // console.log('is called')
    const { payload } = yield take(types.PROVIDER_PLACEORDER_V2)
    const response = yield call(apiDirect, payload)
    yield put(getProviderPlaceOrderV2Response(response))
  }
}

export function* doFetchProductPI() {
  while (true) {
    // console.log('is called')
    const { payload } = yield take(types.FETCH_PRODUCT_PI)
    const response = yield call(apiDirect, payload)
    yield put(fetchProductPIResponse(response))
  }
}

export function* doFetchSubscriptionPI() {
  while (true) {
    // console.log('is called')
    const { payload } = yield take(types.FETCH_SUBSCRIPTION_PI)
    const response = yield call(apiDirect, payload)
    yield put(fetchSubscriptionPIPageRes(response))
  }
}

export function* doPaymentUpdateMembership() {
  while (true) {
    // console.log('is called')
    const { payload } = yield take(types.B2C_MEMBERSHIP_PAYMENT_UPDATE)
    const response = yield call(apiDirect, payload)
    yield put(paymentUpdateMembershipPageRes(response))
  }
}

export function* doFetchSubscribedData() {
  while (true) {
    // console.log('is called')
    const { payload } = yield take(types.FETCH_SUBSCRIBED_DATA)
    const response = yield call(apiDirect, payload)
    yield put(fetchSubscribedDataRes(response))
  }
}

export function* doGetSubscriptionReceiptData() {
  while (true) {
    // console.log('is called')
    const { payload } = yield take(types.VIEW_SUBSCRIPTION_RECEIPT)
    const response = yield call(apiDirect, payload)
    yield put(fetchSubscribedReceiptRes(response))
  }
}

export function* doChangeSubscriptionPlan() {
  while (true) {
    // console.log('is called')
    const { payload } = yield take(types.CHANGE_SUBSCRIPTION_PLAN)
    const response = yield call(apiDirect, payload)
    yield put(changeSubscriptionPlanRes(response))
  }
}

function* checkout() {
  yield fork(doCheckoutSummary)
  yield fork(doFetchPaymentIntent)
  yield fork(doFetchPIDirectCheckout)
  yield fork(doSendOrderPlace)
  yield fork(doZeroSendOrderPlace)
  yield fork(doProviderCheckout)
  yield fork(doProviderPlaceOrder)
  yield fork(doProviderPlaceOrderV2)
  yield fork(doFetchSubscriptionPI)
  yield fork(doPaymentUpdateMembership)
  yield fork(doFetchSubscribedData)
  yield fork(doGetSubscriptionReceiptData)
  yield fork(doChangeSubscriptionPlan)
  yield fork(doFetchProductPI)
}


export default checkout